/// <reference path="../../resources/resources.ts" />
/// <reference path="../../../../teva/dropdown/dropdown.ts" />
/// <reference path="../../../../teva/htmlhelpers/htmlhelpers.ts" />

namespace OfficeGuy.Inputs {
    export class RichText {
        static InitEvents() {
            if ((<any>$(document)).wysiwyg == null)
                return;
            
            $(document)
                .on("click.preventhyperlink", ".og-richtexteditor:not(.og-richtexteditor-disabled) a", function () {
                    return false;
                })
                .on("click.floating-richtext", ".og-richtexteditor:not(.og-richtexteditor-disabled)", function () {
                    var $RichTextContainer = $(this);
                    var $Existing = $(".floating-richtext");
                    if ($Existing.length > 0) {
                        if ($Existing.data("RichText")[0] == $RichTextContainer[0])
                            return;
                        $(document).trigger("click.richtext");
                    }

                    $RichTextContainer.closest(".sumit-field").addClass("sumit-field-active");
                    var $RichText = $RichTextContainer;
                    var $RichTextButtons = $
                        (document.createElement('div')
                            .addClass("floating-richtext"))
                        .append(Inputs.RichText.CreateButtons($RichText.attr("id")));
                    $(document.body).append($RichTextButtons);
                    $RichTextButtons.data("RichText", $RichText);
                    Inputs.RichText.PositionButtons($RichTextContainer, $RichTextButtons, $RichText);

                    (<any>$RichText).wysiwyg();

                    $(window).on("resize.richtext", function () {
                        Inputs.RichText.PositionButtons($RichTextContainer, $RichTextButtons, $RichText);
                    });
                    $(document)
                        .off("click.richtext")
                        .on("click.richtext", function (Event) {
                            if ($(Event.target).closest($RichTextButtons).length == 0 && $(Event.target).closest($RichTextContainer).length == 0) {
                                $RichTextContainer.closest(".sumit-field-active").removeClass("sumit-field-active");
                                $RichTextButtons.remove();
                                $(document).off("click.richtext");
                                $(window).off("resize.richtext");
                            }
                            return true;
                        });
                    return false;
                });
        }        
        static InitEditors(Container?): void {
            if ((<any>$(document)).wysiwyg == null)
                return;

            (<any>$('.og-richtexteditor:not(.og-richtexteditor-disabled)', Container)).wysiwyg();
        }
        static HideFloating() {
            $(".floating-richtext").remove();
            $(document).off("click.richtext");
        }
        static PositionButtons($RichTextContainer, $Buttons, $Input) {
            if ($RichTextContainer.data("richtext-positionselector"))
                $Input = $Input.closest($RichTextContainer.data("richtext-positionselector"));
            $Buttons.css("position", "absolute");
            var Offset = $Input.offset();
            var Top = Offset.top - $Buttons.outerHeight() + 1;
            var Left;
            if (document.body.dir == "rtl") {
                Left = Offset.left + $Input.outerWidth() - $Buttons.outerWidth();
                if (Left < 0)
                    Left = 0;
            }
            else
                Left = Offset.left;

            $Buttons
                .css("left", Left + "px")
                .css("top", Top + "px");
        }
        static CreateButtons(EditorID) {
            return $
                (document.createElement('div')
                    .addClass("floating-richtext-buttons"))
                .attr("data-role", "editor-toolbar")
                .attr("data-target", "#RichTextEditor_" + EditorID)
                .on("click", function () {
                    return false;
                })
                .append($
                    (document.createElement('div')
                        .addClass("teva-dropdown", "og-button-ui-toolbar-group"))
                    .append($
                        (document.createElement('button')
                            .attr("type", "button")
                            .addClass("teva-dropdown-link", "og-button-ui-toolbar-group-button", "using-tooltip")
                            .attr("title", OfficeGuy.Resources.GetString("RichText", "FontSize")))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-text-size")
                        )
                        .on("click", function () {
                            return Teva.Dropdown.DropdownButtonClick($(this));
                        })
                    )
                    .append($(document.createElement('div'))
                        .addClass("teva-dropdown-menu")
                        .append($(document.createElement('a').addClass("teva-dropdown-menu-item"))
                            .attr("data-wysiwyg", "formatBlock h1")
                            .append($(document.createElement('h1'))
                                .text(OfficeGuy.Resources.GetString("RichText", "Header_1"))))
                        .append($(document.createElement('a').addClass("teva-dropdown-menu-item"))
                            .attr("data-wysiwyg", "formatBlock h2")
                            .append($(document.createElement('h2'))
                                .text(OfficeGuy.Resources.GetString("RichText", "Header_2"))))
                        .append($(document.createElement('a').addClass("teva-dropdown-menu-item"))
                            .attr("data-wysiwyg", "formatBlock h3")
                            .append($(document.createElement('h3'))
                                .text(OfficeGuy.Resources.GetString("RichText", "Header_3"))))
                        .append($(document.createElement('a').addClass("teva-dropdown-menu-item"))
                            .attr("data-wysiwyg", "formatBlock h4")
                            .append($(document.createElement('h4'))
                                .text(OfficeGuy.Resources.GetString("RichText", "Header_4"))))
                        .append($(document.createElement('a').addClass("teva-dropdown-menu-item"))
                            .attr("data-wysiwyg", "formatBlock div")
                            .text(OfficeGuy.Resources.GetString("RichText", "Normal")))
                        .append($(document.createElement('a').addClass("teva-dropdown-menu-item"))
                            .attr("data-wysiwyg", "customFontSize")
                            .text(OfficeGuy.Resources.GetString("RichText", "CustomFontSize")))
                    )
                )
                .append($(document.createElement('div'))
                    .addClass("og-button-ui-toolbar-group")
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "bold")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "Bold"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-bold")))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "italic")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "Italic"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-italic")))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "strikethrough")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "Strikethrough"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-strike")))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "underline")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "Underline"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-underline")
                        ))
                )
                .append($(document.createElement('div'))
                    .addClass("og-button-ui-toolbar-group")
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "textColor")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "TextColor"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-text-color")))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "textBackgroundColor")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "TextBackgroundColor"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-bucket")))
                )
                .append($(document.createElement('div'))
                    .addClass("og-button-ui-toolbar-group")
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "insertunorderedlist")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "UnorderedList"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-list")
                        ))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "insertorderedlist")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "OrderedList"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-list-numbered")
                        ))
                )
                .append($(document.createElement('div'))
                    .addClass("og-button-ui-toolbar-group")
                    .append($(document.createElement('a'))
                        .addClass("og-button-ui-toolbar-group-button active-toolbar using-tooltip")
                        .attr("data-wysiwyg", "justifyright")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "JustifyRight"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-align-right", "flip-vertical")
                        ))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "justifycenter")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "JustifyCenter"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-align-center", "flip-vertical")
                        ))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "justifyleft")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "JustifyLeft"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-align-left", "flip-vertical")))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "justifyfull")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "JustifyFull"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-align-justify")))
                )
                .append($(document.createElement('div'))
                    .addClass("og-button-ui-toolbar-group")
                    .append($(document.createElement('a'))
                        .addClass("og-button-ui-toolbar-group-button active-toolbar using-tooltip")
                        .attr("data-wysiwyg", "dirRTL")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "DirectionRTL"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-rtl")))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "dirLTR")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "DirectionLTR"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-ltr")
                        ))
                )
                .append($(document.createElement('div'))
                    .addClass("og-button-ui-toolbar-group")
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "createLink")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "CreateLink"))
                        .append(document.createElement('span')
                            .addClass("icon-sumit-link")
                        ))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "unlink")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "Unlink"))
                        .append(document.createElement('span')
                            .addClass("icon-sumit-unlink")
                        ))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "insertImageUrl")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "InsertImageURL"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-picture")
                        ))
                )
                .append($(document.createElement('div'))
                    .addClass("og-button-ui-toolbar-group")
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "undo")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "Undo"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-ccw")
                        ))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "redo")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "Redo"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-cw")
                        ))
                    .append($(document.createElement('a'))
                        .attr("data-wysiwyg", "removeFormat")
                        .addClass("og-button-ui-toolbar-group-button using-tooltip")
                        .attr("title", OfficeGuy.Resources.GetString("RichText", "RemoveFormat"))
                        .append(document.createElement('span')
                            .addClass("icon-richtext-eraser")
                        ))
                );
        }
    }
}

$(document).on("Teva.Init", function() {
    OfficeGuy.Inputs.RichText.InitEvents();
});

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Inputs.RichText.InitEditors(Container);
});